import React from 'react';

type dataSource = {
  id: string;
  option: 'pix' | 'novo_cartao' | 'cartao_cadastrado' | 'debito';
  card: any;
  text1: string;
  text2: string;
  children: React.ReactNode;
};

export interface Props {
  data: dataSource[];
  setOptionSelected: React.Dispatch<React.SetStateAction<string>>;
  setPagOnlineSelecionado: React.Dispatch<React.SetStateAction<{}>>;
}

const CardSelectOptions: React.FC<Props> = ({ data, setOptionSelected, setPagOnlineSelecionado }) => {
  //const { dadosApp, user } = useContext(GlobalContext);
  const [checked, setChecked] = React.useState('');

  const handleOnClick = (item: dataSource) => {
    setChecked(item.id);
    setOptionSelected(item.option);

    item.card.metodo_pagamento = item.option === 'pix' ? 11 : item.option === 'debito' ? 12 : 0;

    //if (item.option === 'cartao_cadastrado')
    setPagOnlineSelecionado(item.card);
  };
  // border: 2px solid rgb(80, 167, 115);
  // background: rgb(215, 236, 223);
  return (
    <div style={{ marginTop: data?.length > 0 ? 20 : 0 }}>
      {data?.map((item, index) => {
        item.id = index + item.text1.trim();
        return (
          <>
            <div
              key={index}
              className="cardShadow"
              onClick={() => {
                handleOnClick(item);
              }}
              style={{
                margin: '1px 20px',
                padding: 10,
                //border: checked === item.id ? '2px solid #ced4da' : '2px solid #f7f7f7',
                border: checked === item.id ? '2px solid rgb(80, 167, 115)' : '2px solid #f7f7f7',
                background: checked === item.id ? 'rgb(215, 236, 223)' : '#FFFFFF',
                cursor: 'pointer',
              }}
            >
              <div
                style={{
                  padding: '10px',
                  //background: '#f5f6f6',
                  //borderTop: '1px solid rgb(235, 235, 235)',
                  //borderBottom: '1px solid rgb(235, 235, 235)',
                }}
              >
                <label
                  className="containerInputRadio"
                  htmlFor={item.id}
                  style={{
                    //color: checked === item.id ? '#00376b' : '#54656f', //e54750, 54656f
                    color: checked === item.id ? '#e54750' : '#00376b',
                    marginBottom: 0,
                    //fontWeight: '500',
                  }}
                >
                  {item.text1}
                  <div style={{ color: checked === item.id ? '#000000' : 'rgb(115, 115, 115)', fontSize: 14 }}>
                    {item.text2}
                  </div>
                  <input
                    id={item.id}
                    type="radio"
                    value={item.id}
                    name="opcao"
                    checked={checked === item.id}
                    onChange={() => handleOnClick(item)}
                  />
                  <span
                    className="checkmark"
                    style={{ top: item.text2 ? 12 : 2, border: checked === item.id ? '2px solid #e54750' : '' }}
                  ></span>
                </label>
                {/* {checked === item.id && item.children} */}
              </div>
            </div>
            {/* {item.children} */}
          </>
        );
      })}
    </div>
  );
};

export default CardSelectOptions;
